/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Resources_Billing_Frequency_MonthsInputs */

const en_admin_resources_billing_frequency_months = /** @type {(inputs: Admin_Resources_Billing_Frequency_MonthsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Billing frequency (months)`)
};

const de_admin_resources_billing_frequency_months = /** @type {(inputs: Admin_Resources_Billing_Frequency_MonthsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abrechnungsintervall (Monate)`)
};

const es_admin_resources_billing_frequency_months = /** @type {(inputs: Admin_Resources_Billing_Frequency_MonthsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Frecuencia de facturación (meses)`)
};

const fr_admin_resources_billing_frequency_months = /** @type {(inputs: Admin_Resources_Billing_Frequency_MonthsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fréquence de facturation (mois)`)
};

const nl_admin_resources_billing_frequency_months = /** @type {(inputs: Admin_Resources_Billing_Frequency_MonthsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Factureringsfrequentie (maanden)`)
};

/** @type {(inputs: Admin_Resources_Billing_Frequency_MonthsInputs) => LocalizedString} */
const it_admin_resources_billing_frequency_months = en_admin_resources_billing_frequency_months;

/** @type {(inputs: Admin_Resources_Billing_Frequency_MonthsInputs) => LocalizedString} */
const pt_br2_admin_resources_billing_frequency_months = en_admin_resources_billing_frequency_months;

/** @type {(inputs: Admin_Resources_Billing_Frequency_MonthsInputs) => LocalizedString} */
const pl_admin_resources_billing_frequency_months = en_admin_resources_billing_frequency_months;

/** @type {(inputs: Admin_Resources_Billing_Frequency_MonthsInputs) => LocalizedString} */
const hu_admin_resources_billing_frequency_months = en_admin_resources_billing_frequency_months;

/** @type {(inputs: Admin_Resources_Billing_Frequency_MonthsInputs) => LocalizedString} */
const ro_admin_resources_billing_frequency_months = en_admin_resources_billing_frequency_months;

/**
* | output |
* | --- |
* | "Billing frequency (months)" |
*
* @param {Admin_Resources_Billing_Frequency_MonthsInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_resources_billing_frequency_months = /** @type {((inputs?: Admin_Resources_Billing_Frequency_MonthsInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Resources_Billing_Frequency_MonthsInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_resources_billing_frequency_months(inputs)
	if (locale === "de") return de_admin_resources_billing_frequency_months(inputs)
	if (locale === "es") return es_admin_resources_billing_frequency_months(inputs)
	if (locale === "fr") return fr_admin_resources_billing_frequency_months(inputs)
	if (locale === "nl") return nl_admin_resources_billing_frequency_months(inputs)
	if (locale === "it") return it_admin_resources_billing_frequency_months(inputs)
	if (locale === "pt-BR") return pt_br2_admin_resources_billing_frequency_months(inputs)
	if (locale === "pl") return pl_admin_resources_billing_frequency_months(inputs)
	if (locale === "hu") return hu_admin_resources_billing_frequency_months(inputs)
	return ro_admin_resources_billing_frequency_months(inputs)
});
export { admin_resources_billing_frequency_months as "admin.resources.billing_frequency_months" }